import(/* webpackMode: "eager" */ "/vercel/path0/app/instructor/register/page.tsx");
